import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from '../../../store';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";

class BygenreTask extends AbstractRequestTask {

    constructor(url = "") {
        super();
        this.url = url;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
        const http = "https://";
        const urlmf = Launcher.get("akamai_mfwk");
        return `${http}${urlmf}${this.url}`;
    }

    getParams() {

        const params = super.getParams();
        const epg_version = DeviceStorage.getItem('epgVersion');
        const user = store.getState().user;
        const lasttouch = user && user.lasttouch ? user.lasttouch.purchased : false;

        if (lasttouch) {
            params.lasttouch = lasttouch;
        }

        if(epg_version){
            params.epg_version = epg_version;
        }

        delete params.device_name;
        delete params.user_id;
        delete params.user_token;
        delete params.HKS;
        delete params.api_version;
        delete params.device_so;
        delete params.format;
        delete params.device_id;

        return Object.assign({}, params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
}

export default BygenreTask;





// WEBPACK FOOTER //
// ./src/requests/tasks/cms/BygenreTask.js